import { TransactionType } from '../@types/transaction_type';
import axios from '../utils/axios';

export const fetchAll = async (): Promise<TransactionType[]> => {
  const response = await axios.get('transaction-types');
  return response.data;
};
